import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { useErrorBoundary } from 'react-error-boundary';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Card, Button, Box, IconButton, Divider, TableContainer, Table, TableCell, TableHead, TableBody, TableRow, Link, Paper, CardContent, useTheme, useMediaQuery } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import dayjs from 'dayjs';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Subscription from '../../Home1/components/Subscription/Subscription';

import CalendarEvent from '../../../types/communication/calendarEvent';
import '../../Home1/view-home.css';

const EducationMultimedia = (): JSX.Element => {

  const { showBoundary } = useErrorBoundary();
  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));

  const [isListView, setIsListView] = useState(false);


  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentMonthEvents, setCurrentMonthEvents] = useState<CalendarEvent[]>([]);


  const [value, setValue] = useState('1');

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width <= 768;

  const Multimedia = [
    {
      link: 'https://www.youtube.com/user/ocpfreports',
      icon: <YouTubeIcon sx={{fontSize: 40, color: 'red'}} />
    },
    {
      link: 'https://twitter.com/OCPFReports',
      icon: <XIcon sx={{fontSize : 40}} />
    },
    {
      link: 'https://www.instagram.com/ocpfreports/',
      icon: <InstagramIcon  sx={{fontSize : 40}}/>
    },
    {
      link: 'https://www.facebook.com/massocpf',
      icon: <FacebookIcon sx={{fontSize : 40, color: 'blue'}} />
    }
   
  ]

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const getEventsByYearAndMonth = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/events/${year}/${month}`)
        .then(result => {
          if (!result.ok) {
            showBoundary(new Error('Failed to get events by year and month.'));
          }
          return result.json();
        })
        .then(result => {
          setCurrentMonthEvents(result);
        });
    } catch (error) {
      console.error('Uncaught Error:', error);
    }
  }

  const updateMonthForward = () => {
    let newDate = dayjs(currentDate).add(1, 'month').toDate();
    setCurrentDate(newDate);
    setMonth(newDate.getMonth() + 1);
    setYear(newDate.getFullYear());

  }

  const updateMonthBackward = () => {
    let newDate = dayjs(currentDate).subtract(1, 'month').toDate();
    setCurrentDate(newDate);
    setMonth(newDate.getMonth() + 1);
    setYear(newDate.getFullYear());
  }

  useEffect(() => {
    getEventsByYearAndMonth();
  }, [month, year])

  const renderVideos = () => {
    return (
      <>
        <Typography
          variant="h4"
          align={'center'}
          data-aos={'fade-up'}
          gutterBottom
          sx={{ fontWeight: 700 }}
        >
          Featured Videos
        </Typography>
        <Box sx={{ padding: 2 }}>
          <Card sx={{ marginBottom: 2 }}>
            <Link sx={{ color: 'black', textDecoration: 'none' }} href='https://www.youtube.com/watch?v=Ce09jG2PDKQ' target='_blank'>
              <Grid container alignItems={'center'}>
                <Grid size={isMobile ? 2 : 1} padding={1}>
                  <YouTubeIcon sx={{color: 'red', fontSize: 20}} />
                </Grid>
                <Grid size={isMobile ? 10 : 11}>
                  <Typography variant='body2' gutterBottom>
                    <b>How to e-file a depository report</b>
                  </Typography>
                  <Typography variant='subtitle2'>
                    (For depository candidates and committees.)
                  </Typography>

                </Grid>
              </Grid>
            </Link>

          </Card>
          <Card sx={{ marginBottom: 2 }}>
            <Link sx={{ color: 'black', textDecoration: 'none' }} href='https://www.youtube.com/watch?v=Ce09jG2PDKQ' target='_blank'>
              <Grid container alignItems={'center'}>
                <Grid size={isMobile ? 2 : 1} padding={1}>
                  <YouTubeIcon sx={{color: 'red', fontSize: 20}} />
                </Grid>
                <Grid size={isMobile ? 10 : 11}>
                  <Typography variant='body2' gutterBottom>
                    <b>How to create, operate and report on the local level</b>
                  </Typography>
                  <Typography variant='subtitle2'>(For candidates and committees who file with local election officials.)</Typography>


                </Grid>
              </Grid>
            </Link>
          </Card>

          <Button variant='contained' fullWidth href='/Publications/Videos' target='_blank'>View the complete playlist of OCPF Instructional Videos</Button>
        </Box>
      </>
    )
  }


  const renderDay = (day: dayjs.Dayjs, events: CalendarEvent[]) => {
    let isToday = dayjs().format('M/D/YYYY') === day.format('M/D/YYYY');

    return (
      <TableCell
        key={day.format('M/D/YYYY')}
        align='center'
        sx={{
          border: 0.25,
          borderColor: isToday ? 'black' : 'grey.300',
          position: 'relative',
          padding: isMobile ? '4px' : '8px',
          verticalAlign: 'top',
          '&.MuiTableCell-root': {
            boxSizing: 'border-box',
            minWidth: isMobile ? '50px' : '100px', // Minimum width to prevent cramping
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            height: '100%',
            // Add overflow handling for content
            textWrap: 'pretty',
            overflow: 'auto'
          }}
        >
          {/* Day number in top-left corner */}
          <IconButton
            key={day.format('M/D/YYYY') + '-number'}
            size='small'
            disabled
            component={'span'}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              padding: isMobile ? '2px' : '4px',
              minWidth: 'auto',
              // Ensure day number stays visible when scrolling
              backgroundColor: 'background.paper',
              zIndex: 1,
              color: 'black', // This will make the icon/text black
              '&.Mui-disabled': {
                color: 'black' // This ensures it stays black even when disabled
              },
              fontSize: isMobile ? '0.75rem' : 'inherit'

            }}
          >
            {day.date()}
          </IconButton>

          {/* Events container with padding to avoid overlapping with day number */}
          <Box
            sx={{
              pt: isMobile ? 3 : 5, // Less top padding on mobile
              width: '100%',
              pb: isMobile ? 0.5 : 1 // Less bottom padding on mobile
            }}
          >
            {events.map((event: CalendarEvent) => (
              <Typography
                key={event.id}
                variant={isMobile ? 'caption' : 'subtitle2'} // Smaller text on mobile
                display={'block'}
                sx={{ mb: isMobile ? 0.5 : 1 }} // Less margin on mobile
              >
                {event.isHoliday ? event.title :
                  <Link
                    href='https://ocpfreporter.us/SeminarRegistration/'
                    target='_blank'
                    sx={{
                      textDecoration: 'none',
                      '&:hover': {
                        textDecoration: 'underline'
                      },
                      fontSize: isMobile ? '0.75rem' : 'inherit' // Smaller font size on mobile
                    }}
                  >
                    {event.startTime + ' ' + event.title}
                  </Link>

                }
                <Typography
                  variant='caption'
                  component="div"
                  sx={{
                    fontStyle: 'italic',
                    mt: isMobile ? 0.25 : 0.5, // Less margin on mobile
                    fontSize: isMobile ? '0.65rem' : '0.75rem' // Even smaller description text on mobile
                  }}
                >
                  {event.description}
                </Typography>
              </Typography>
            ))}
          </Box>
        </Box>
      </TableCell>
    );
  };

  const renderCalendar = () => {
    let daysInMonth = dayjs(`${year}-${month}`, 'YYYY-M').daysInMonth();
    let firstDayOfMonth = dayjs(`${year}-${month}-1`, 'YYYY-M-D').day();
    let count = 1;

    return (
      <TableContainer>
        <Table sx={{
          width: isMobile ? '95%' : '100%', tableLayout: 'fixed', borderCollapse: 'separate', borderSpacing: 0,
          '& .MuiTableCell-head': {
            padding: isMobile ? '4px 2px' : '16px', // Adjust header cell padding for mobile
            fontSize: isMobile ? '0.75rem' : 'inherit' // Smaller header text on mobile
          }
        }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: '#2f96b4', color: 'white' }} colSpan={7} align={'center'} >
                <Grid container>
                  <Grid size={1}><Button aria-label='Go back a month' title='Go back a month' variant='outlined' sx={{ backgroundColor: 'white', color: 'black' }} onClick={() => updateMonthBackward()}><NavigateBeforeIcon /></Button></Grid>
                  <Grid size={10} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Typography variant="h5">
                      {dayjs(`${year}-${month}`, 'YYYY-M').format('MMMM')} {year}
                    </Typography>
                  </Grid>

                  <Grid size={1}><Button aria-label='Go forward a month' title='Go forward a month' variant='outlined' sx={{ backgroundColor: 'white', color: 'black' }} onClick={() => updateMonthForward()}><NavigateNextIcon /></Button></Grid>
                </Grid>

              </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
              <TableCell align='center'>{isMobile ? 'Sun' : 'Sunday'}</TableCell>
              <TableCell align='center'>{isMobile ? 'Mon' : 'Monday'}</TableCell>
              <TableCell align='center'>{isMobile ? 'Tues' : 'Tuesday'}</TableCell>
              <TableCell align='center'>{isMobile ? 'Wed' : 'Wednesday'}</TableCell>
              <TableCell align='center'>{isMobile ? 'Thurs' : 'Thursday'}</TableCell>
              <TableCell align='center'>{isMobile ? 'Fri' : 'Friday'}</TableCell>
              <TableCell align='center'>{isMobile ? 'Sat' : 'Saturday'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from(Array(Math.ceil((daysInMonth + firstDayOfMonth) / 7)).keys()).map((week: number) => {

              return (
                <TableRow key={week}>
                  {Array.from(Array(7).keys()).map((dayOfWeek: number, index: number) => {

                    if (firstDayOfMonth === index && week === 0) {
                      let day = dayjs(`${year}-${month}-1`, 'M/D/YYYY');
                      let events = currentMonthEvents.filter((event: CalendarEvent) => dayjs(event.date).format('M/D/YYYY') === day.format('M/D/YYYY'));
                      count++;
                      return renderDay(day, events);
                    } else if ((week > 0 || index > firstDayOfMonth) && (count <= daysInMonth)) {
                      let day = dayjs(`${year}-${month}-${count}`, 'M/D/YYYY');
                      let events = currentMonthEvents.filter((event: CalendarEvent) => dayjs(event.date).format('M/D/YYYY') === day.format('M/D/YYYY'));
                      count++;
                      return renderDay(day, events);
                    } else {
                      return <TableCell sx={{ border: 0.25, borderColor: 'grey.300', }} key={dayOfWeek}></TableCell>
                    }
                  })}
                </TableRow>
              )
            })
            }



          </TableBody>
        </Table>
      </TableContainer>
    );

  }

  const renderCalendarList = () => {
    return (
      <Box width={{ xs: '90%', md: '50%' }} component={Paper} sx={{ padding: 2 }} className="seminarsContainer">
        <Grid container sx={{ backgroundColor: '#2f96b4', color: 'white' }} marginBottom={4} marginRight={2}>
          <Grid size={1}><Button size="small" aria-label='Go back a month' title='Go back a month' variant='outlined' sx={{ backgroundColor: 'white', color: 'black' }} onClick={() => updateMonthBackward()}><NavigateBeforeIcon /></Button>
          </Grid>
          <Grid size={10} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Typography variant="h5">
              {dayjs(`${year}-${month}`, 'YYYY-M').format('MMMM')} {year}
            </Typography>
          </Grid>
          <Grid size={1}><Button size="small" aria-label='Go forward a month' title='Go forward a month' variant='outlined' sx={{ backgroundColor: 'white', color: 'black' }} onClick={() => updateMonthForward()}><NavigateNextIcon /></Button></Grid>
        </Grid>
        {currentMonthEvents.map((item: CalendarEvent) => {
          return (
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              display={'flex'}
              flexDirection={'row'}
              marginBottom={2}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Box
                sx={{
                  width: '20%',
                  marginRight: 2,
                }}
              >
                <div className="calendarDate">
                  <em>{new Date(item.date).toLocaleDateString('default', { weekday: 'short' })}</em>
                  <strong>{item.dateDisplayMonth} {item.dateDisplayYear}</strong>
                  <span>{item.dateDisplayDay}</span>
                </div>
              </Box>
              <CardContent
                sx={{
                  padding: 0,
                  width: '80%',
                  '&:last-child': { paddingBottom: 1 }
                }}
              >
                <Typography variant={'body2'} fontWeight={600} component={Link} href={`https://ocpfreporter.us/SeminarRegistration/?seminarEventId=${item.id}`} underline="none">{item.startTime} {item.title}</Typography>
                <Box marginY={1 / 4}>
                  <Typography
                    variant={'body2'}
                    color={'text.primary'}
                    component={'i'}
                  >
                    {item.description}
                  </Typography>
                </Box>
              </CardContent>
            </Box>
          )
        })}
      </Box>
    )
  }

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
          variant="h5"
          align={'left'}
          data-aos={'fade-up'}
          sx={{
            fontWeight: 700,
          }}
          paddingTop={3}
          gutterBottom
          marginBottom={2}
        >
          Education and Multimedia Resources
        </Typography>
        <Divider />

        <Box sx={{ marginTop: 2 }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Seminar Calendar" value="1" />
                <Tab label="Educational Seminars" value="2" />
                <Tab label="Multimedia" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1">
              {
                !isSM &&
                <Box marginBottom={2} alignItems={'right'} display={'flex'} justifyContent={'flex-start'}>
                  <Button onClick={() => setIsListView(false)}>Calendar View</Button>
                  <Button onClick={() => setIsListView(true)}>List View</Button>
                </Box>
              }
              {!isSM && !isListView &&
                renderCalendar()
              }
              {
                (isSM || isListView) &&
                renderCalendarList()
              }
            </TabPanel>
            <TabPanel value="2">
              <Typography variant="h6" gutterBottom>
                <b>Request Seminars or Training Sessions</b>
              </Typography>
              <Typography variant="body1" gutterBottom>
                OCPF regularly schedules seminars to assist new candidates and committees with understanding the requirements and restrictions of campaign finance law. OCPF also provides seminars to interested parties on a variety of campaign finance topics and schedules individual training sessions for candidates and committees.
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                <b>
                  Educational Seminars
                </b>
              </Typography>
              <Typography variant="body1" gutterBottom>
                Online Educational Seminars: Twice monthly, on Wednesdays, OCPF hosts a 60 minute educational training class for depository candidates who file with OCPF and political action committees. The staff will be available to answer your questions, instruct individuals on using the Reporter software, and offer guidance on issues of interest. OCPF also periodically hosts training classes for municipal candidates who file locally, public employees, and local party committees (please check the seminar calendar for those dates). OCPF training classes are conducted using online video conferencing (Zoom).
              </Typography>
              <Typography variant="h6" gutterBottom>
                <b>Scheduled Educational Seminars</b>
              </Typography>
              <Typography component={'span'} variant="body1" gutterBottom>
                OCPF provides seminars on a variety of topics including, but not limited to:
                <ul>
                  <li>Filing and disclosure requirements for all types of candidates, PACs and other committees;</li>
                  <li>General information for new candidates;</li>
                  <li>The application of the campaign finance law to political activity by public employees, including the restriction on employees' fundraising and on fundraising in government buildings;</li>
                  <li>Restrictions on the use of public resources to influence voters in ballot question elections on the local level, especially Proposition 2½ overrides; and</li>
                  <li>Electronic Filing.</li>
                </ul>
                OCPF also provides scheduled one-on-one training sessions, such as software training or informational meetings for new candidates. If you are interested in scheduling a seminar or training session, please contact OCPF by phone at (617) 979-8300 or e-mail us at <Link href='mailto:ocpf@mass.gov?subject=Seminar/Training%20Request'>ocpf@mass.gov</Link>.
              </Typography>
            </TabPanel>
            <TabPanel value="3">
              <Grid container spacing={2}>
                


                {isMobile && <Box component={Paper} sx={{ padding: 2 }}>{renderVideos()}</Box>}
                {!isMobile && <Grid size={6}>
                  <Box component={Paper} sx={{ padding: 2 }}>
                    {renderVideos()}
                  </Box>
                </Grid>}

                <Grid size={isMobile ? 12 : 6}>
                  <Subscription />
                </Grid>

                <Grid size={12}>
                  <Box component={Paper} sx={{ padding: 2 }}>
                    <Typography
                      variant="h4"
                      align={'center'}
                      data-aos={'fade-up'}
                      gutterBottom
                      sx={{ fontWeight: 700 }}
                    >
                      Follow us
                    </Typography>

                    <Box
                      width={1}
                      display="flex"
                      alignItems={{ xs: 'stretched', sm: 'flex-start' }}
                      justifyContent={'center'}
                    >
                      {Multimedia.map((item, index) => {
                        return (
                          <IconButton key={index} href={item.link} target='_blank'>
                            {item.icon}
                          </IconButton>
                        )
                      })}
                    </Box>
                  </Box>

                </Grid>


              
              </Grid>

            </TabPanel>
          </TabContext>
        </Box>


      </Container>
    </Main>
  );
};

export default EducationMultimedia;